import type { SVGProps } from 'react';

const SvgUserOnFilled = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 24 24' fill='none' width='1em' height='1em' focusable='false' color='currentColor' {...props}>
    <path
      d='M12 14.25C14.3537 14.25 16.5154 14.9646 18.1055 16.1562C19.6956 17.3481 20.75 19.0524 20.75 21C20.75 21.4142 20.4142 21.75 20 21.75H4C3.58579 21.75 3.25 21.4142 3.25 21C3.25 19.0524 4.30439 17.3481 5.89453 16.1562C7.48455 14.9646 9.64631 14.25 12 14.25ZM12 2.25C14.6234 2.25 16.75 4.37665 16.75 7C16.75 9.62335 14.6234 11.75 12 11.75C9.37665 11.75 7.25 9.62335 7.25 7C7.25 4.37665 9.37665 2.25 12 2.25Z'
      fill='currentColor'
    />
    <circle cx={22} cy={2} r={2} fill='#FF5A5A' />
  </svg>
);
export default SvgUserOnFilled;
